import { render, staticRenderFns } from "./ThreeDotMenu.vue?vue&type=template&id=3329f77b&scoped=true"
import script from "./ThreeDotMenu.vue?vue&type=script&lang=ts"
export * from "./ThreeDotMenu.vue?vue&type=script&lang=ts"
import style0 from "./ThreeDotMenu.vue?vue&type=style&index=0&id=3329f77b&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3329f77b",
  null
  
)

export default component.exports